/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { DeviceInfo } from '../DeviceInfo';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
  },
}));

const Complete = () => {
  const classes = useStyles();
  const updatedDevice = useSelector((state) => state.devices.currentDevice);

  return (
    <div>
      <h4 className={classes.title}>Neuralert wrist monitor successfully linked to patient</h4>
      {updatedDevice && <DeviceInfo device={updatedDevice} actions={false} />}
    </div>
  );
};

export default Complete;
